export class Coupon {
  gcn?: string;
  campaignStart?: Date;

  constructor(gcn?: string, campaignStart?: Date) {
    this.gcn = gcn;
    this.campaignStart = campaignStart;
  }
}
// export class CouponDetailed {
//   gcn = "";
//   validFrom = "";
//   validUntil = "";
//   base64image = "";
//   descriptionList = [] as { value: string }[];
//   couponActive?: boolean = true;
//   couponName?: string;
//   couponValidUntil = [] as Date[];
//   couponDisclaimer?: string;
// }

export class CouponDetailed {
  gcn = "";
  validFrom = "";
  validUntil = "";
  descriptionList = [] as { value: string; language: string }[];
  couponActive?: boolean = true;
  maxUses = 0;
  discountActionId = "";
}

export class Campaigns {
  campaigns = [] as CouponDetailed[];
}

// export class SendCouponModel {
//   barcode_base64image = "";
//   name = "";
//   discount = "";
//   valid_from = "";
//   valid_until = "";
//   status = "";
//   email_address = "";
//   card_number = "";
//   PLUS_DAYS = "";
// }

export class CouponForm {
  validPeriod = [] as Date[];
  name?: string;
  status?: CouponStatuses;
  gcn?: string;
  authId?: string;
  disclaimer?: string;
  discount?: number;
  barcodeImage?: string;
}

export enum CouponStatuses {
  expired = "EXPIRED",
  active = "ACTIVE",
  notActive = "NOTACTIVE",
  none = "NONE",
}

export const couponStatusLabels: { [key in CouponStatuses]: string } = {
  [CouponStatuses.expired]: "Истёк",
  [CouponStatuses.active]: "Активный",
  [CouponStatuses.notActive]: "Неактивный",
  [CouponStatuses.none]: "",
};
